import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class AutoCompleteStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.results = [];
  }

  handleLoadSuccess(results) {
    this.results = results;
    this.emitChange();
  }

  get() {
    return {
      results: this.results
    };
  }

  dehydrate() {
    return {
      results: this.results
    };
  }

  rehydrate(state) {
    this.results = state.results;
  }
}

AutoCompleteStore.storeName = 'AutoCompleteStore';
AutoCompleteStore.handlers = {
  [Actions.LOAD_AUTOCOMPLETESERVICE_SUCCESS]: 'handleLoadSuccess'
};

export default AutoCompleteStore;


// WEBPACK FOOTER //
// ./src/stores/AutoCompleteStore.js